// extracted by mini-css-extract-plugin
module.exports = {"scrollBarWrap":"styles_scrollBarWrap__mJp2p","scrollBarVWrap":"styles_scrollBarVWrap__1zTRb"};